var _circle, _circle2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExplore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.3695,
    cy: 10.3695,
    r: 10.3695,
    fill: "#D9D9D9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.3081,
    cy: 10.3081,
    r: 8.30811,
    fill: "#D9D9D9",
    stroke: "white",
    strokeWidth: 0.639085
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.76127 14V7.02994H10.8063C11.538 7.02994 12.1048 7.19142 12.5068 7.51438C12.9089 7.83075 13.1099 8.27235 13.1099 8.83919C13.1099 9.21488 13.0144 9.53784 12.8232 9.80808C12.6321 10.0783 12.3684 10.276 12.0323 10.4013C12.4278 10.5133 12.7342 10.7111 12.9517 10.9945C13.1758 11.2713 13.2879 11.6239 13.2879 12.0523C13.2879 12.6719 13.077 13.153 12.6551 13.4958C12.2399 13.8319 11.6599 14 10.9151 14H7.76127ZM8.97732 9.98603H10.5888C11.4523 9.98603 11.884 9.65319 11.884 8.98749C11.884 8.32179 11.4523 7.98894 10.5888 7.98894H8.97732V9.98603ZM8.97732 13.041H10.7569C11.6269 13.041 12.0619 12.6917 12.0619 11.993C12.0619 11.2944 11.6269 10.945 10.7569 10.945H8.97732V13.041Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplore);
export default __webpack_public_path__ + "static/media/explore.79c9671d060ea05b4851c0953e9785e3.svg";
export { ForwardRef as ReactComponent };